import { render, staticRenderFns } from "./MemberRights.vue?vue&type=template&id=1470b890&scoped=true&"
import script from "./MemberRights.vue?vue&type=script&lang=js&"
export * from "./MemberRights.vue?vue&type=script&lang=js&"
import style0 from "./MemberRights.vue?vue&type=style&index=0&id=1470b890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470b890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VIcon,VRow,VSwitch})
